import Boxes from './content/two-column-box-content/index';
import CtaImage from './content/banner-with-cta/index';
import Filters from './filters/index';
import Footer from './footer/index';
import Header from './header/main';
import HeroImage from './hero/index';
import PdfModal from './business/case/case';
import SecondNavigation from './second-navigation/index';

export default () => {
    new Header(document.querySelector(".main-header"));
    new SecondNavigation(document.querySelector(".breadcrumb-wrap"));
    new PdfModal(document.querySelectorAll(".pdf-modal"));
    new Boxes(document.querySelectorAll(".home-news"));
    new HeroImage(document.querySelector(".hero-image-home"));
    new CtaImage(document.querySelector(".home-people"));
    new Filters(document.querySelector("#misha_filters"));
    new Footer(document.querySelector(".footer"));
};
